module.exports = __webpack_public_path__ + "static/media/Schoolinka.51824adb.jpeg";